import { defineStore } from 'pinia'
import { isMobile } from '~/utils/user-agents'

type TStoreState = {
  nativeShare: boolean,
  isMobile: boolean
};

/*
  checks what is supported on app launch so we won't have to wait for individual
  components to load/mount, gives better performance.
*/
export const useBrowserSupportStore = defineStore('client', {
  state: (): TStoreState => {
    return {
      nativeShare: false,
      isMobile: true
    }
  },
  actions: {
    setNativeShareSupported () {
      this.$state.nativeShare = !!(window.navigator.share)
      console.info(
        `✔ Browser supports NativeShare API: ${this.$state.nativeShare}`
      )
    },
    setIsMobile () {
      this.$state.isMobile = !!isMobile.any()
    }
  },
  getters: {
    isNativeShareSupported: state => state.nativeShare,
    isMobileDevice: state => state.isMobile
  }
})
